import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { style: {"background-color":"#ffffff"} }
const _hoisted_2 = { class: "tbldiv" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div id=\"divNoticeMsg\"> If the approval process is pending, you cannot place a check mark on the permission. </div><div id=\"divNoticeMsg2\"> If you have any question for menu permission, Please contact the person in charge of each menu directly via following screen. 【 ? 】→ 【Contact Information】 </div><div style=\"width:1000px;overflow:hidden;margin-left:3%;\"><table id=\"permissiontbl1\"><!-- 2023/04/17 MDCR 修正 start --><!-- &lt;tr&gt;\n              &lt;th colspan=&quot;3&quot;&gt;Permission List&lt;/th&gt;\n            &lt;/tr&gt; --><tr><th style=\"width:30%;text-align:center;\">Main</th><th style=\"width:30%;text-align:center;\">Sub</th><th style=\"width:5%;text-align:center;\"></th><th style=\"width:35%;text-align:center;\">Status</th></tr><!-- 2023/04/17 MDCR 修正 end --></table></div>", 3)
const _hoisted_6 = {
  key: 0,
  style: {"text-align":"center","height":"calc(96% - 150px)"}
}
const _hoisted_7 = { style: {"width":"932px","height":"430px","overflow-x":"hidden","overflow-y":"auto","margin-left":"3%"} }
const _hoisted_8 = { id: "permissiontbl" }
const _hoisted_9 = { style: {"width":"30%","height":"30.5px"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_11 = {
  class: "chkBox",
  style: {"width":"5%","height":"30.5px"}
}
const _hoisted_12 = ["id", "onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"35%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_15 = { style: {"width":"30%","height":"30.5px"} }
const _hoisted_16 = {
  class: "chkBox",
  style: {"width":"5%","height":"30.5px"}
}
const _hoisted_17 = ["id", "name", "onClick"]
const _hoisted_18 = { style: {"width":"35%","height":"30.5px"} }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { style: {"width":"30%","height":"30.5px"} }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_22 = {
  class: "chkBox",
  style: {"width":"5%","height":"30.5px"}
}
const _hoisted_23 = ["id", "name", "onClick"]
const _hoisted_24 = { style: {"width":"35%","height":"30.5px"} }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { style: {"width":"30%","height":"30.5px"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_28 = {
  class: "chkBox",
  style: {"width":"5%","height":"30.5px"}
}
const _hoisted_29 = ["id", "onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"35%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_31 = {
  key: 0,
  style: {"width":"15%","height":"30.5px"}
}
const _hoisted_32 = {
  key: 1,
  style: {"width":"30%","height":"30.5px"}
}
const _hoisted_33 = { style: {"width":"30%","height":"30.5px"} }
const _hoisted_34 = {
  class: "chkBox",
  style: {"width":"5%","height":"30.5px"}
}
const _hoisted_35 = ["id", "name", "onClick"]
const _hoisted_36 = { style: {"width":"35%","height":"30.5px"} }
const _hoisted_37 = { style: {"float":"center","width":"932px","margin-top":"2%","display":"flex","justify-content":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode($setup["Navigation"]),
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
      _createVNode($setup["UserLinkNavigation"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        ($setup.permissionDetail.length == 0 && $setup.getData)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_6, " No data "))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.permissionDetail, (info, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (
                  index == 0 &&
                  info.mainTitleCode.mainTitleName ==
                    $setup.permissionDetail[index + 1].mainTitleCode.mainTitleName
                )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_9, _toDisplayString(info.mainTitleCode.mainTitleName), 1 /* TEXT */),
                        _hoisted_10,
                        _createElementVNode("td", _hoisted_11, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            id: 'chkHeader' + info.mainTitleCode.mainTitleName,
                            name: "chkHeader",
                            style: {"visibility":"hidden"},
                            onClick: ($event: any) => ($setup.chkHeaderChange(info.mainTitleCode.mainTitleName))
                          }, null, 8 /* PROPS */, _hoisted_12)
                        ]),
                        _hoisted_13
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_14,
                        _createElementVNode("td", _hoisted_15, _toDisplayString(info.mainMenuName), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_16, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            id: 'chk' + info.mainMenuCode,
                            name: 'chk' + info.mainTitleCode.mainTitleName,
                            onClick: ($event: any) => ($setup.chkChange(info.mainTitleCode.mainTitleName))
                          }, null, 8 /* PROPS */, _hoisted_17)
                        ]),
                        _createElementVNode("td", _hoisted_18, _toDisplayString($setup.statusPermisList[index]), 1 /* TEXT */)
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : (
                  index == 0 &&
                  info.mainTitleCode.mainTitleName !=
                    $setup.permissionDetail[index + 1].mainTitleCode.mainTitleName
                )
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                        _createElementVNode("td", _hoisted_20, _toDisplayString(info.mainTitleCode.mainTitleName), 1 /* TEXT */),
                        _hoisted_21,
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            id: 'chk' + info.mainMenuCode,
                            name: 'chk' + info.mainTitleCode,
                            onClick: ($event: any) => ($setup.chkChange(info.mainTitleCode))
                          }, null, 8 /* PROPS */, _hoisted_23)
                        ]),
                        _createElementVNode("td", _hoisted_24, _toDisplayString($setup.statusPermisList[index]), 1 /* TEXT */)
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (
                    info.mainMenuName != '' &&
                    info.mainTitleCode.mainTitleName !=
                      $setup.permissionDetail[index - 1].mainTitleCode.mainTitleName
                  )
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                              _createElementVNode("td", _hoisted_26, _toDisplayString(info.mainTitleCode.mainTitleName), 1 /* TEXT */),
                              _hoisted_27,
                              _createElementVNode("td", _hoisted_28, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  id: 'chkHeader' + info.mainTitleCode.mainTitleName,
                                  name: "chkHeader",
                                  style: {"visibility":"hidden"},
                                  onClick: ($event: any) => ($setup.chkHeaderChange(info.mainTitleCode.mainTitleName))
                                }, null, 8 /* PROPS */, _hoisted_29)
                              ]),
                              _hoisted_30
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("tr", null, [
                          (info.mainMenuName == '')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_31, _toDisplayString(info.mainTitleCode.mainTitleName), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock("td", _hoisted_32)),
                          _createElementVNode("td", _hoisted_33, _toDisplayString(info.mainMenuName), 1 /* TEXT */),
                          _createElementVNode("td", _hoisted_34, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              id: 'chk' + info.mainMenuCode,
                              name: 'chk' + info.mainTitleCode.mainTitleName,
                              onClick: ($event: any) => ($setup.chkChange(info.mainTitleCode.mainTitleName))
                            }, null, 8 /* PROPS */, _hoisted_35)
                          ]),
                          _createElementVNode("td", _hoisted_36, _toDisplayString($setup.statusPermisList[index]), 1 /* TEXT */)
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("button", {
            class: "button-apply",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.insertUserPermission()))
          }, " Update ")
        ])
      ])
    ])
  ]))
}